import Axios from 'axios';
import router from '../router';

export default {
	state: {
		calls: null,
		call: null
	},
	mutations: {
		SET_CALLS (state, calls) {
			state.calls = calls;
		},
		SET_CALL (state, call) {
			state.call = call;
		}
	},
	actions: {
	 	async createCall (context, call) {
			try {
				const response = await Axios.post('/callcenter/calls', call);
				router.push('/calls');
			} catch (error) {
				console.log(error);
				throw error;
			}
		},
		async getCalls (context) {
			try {
				const response = await Axios.get('/callcenter/calls');
				context.commit('SET_CALLS', response.data);
			} catch (error) {
				console.log(error);
				throw error;
			}
		},
		async getCall (context, callId) {
			try {
				const response = await Axios.get(`/callcenter/calls/${callId}`);
				context.commit('SET_CALL', response.data);
			} catch (error) {
				console.log(error);
				throw error;
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/calls.js